import { Link } from './link.model';
import { Injectable } from '@angular/core';

@Injectable()
export class ClaimsResponse {
    stateCode?: string;
    number?: string;
    links?: Array<Link>;
}
